<mat-form-field [appearance]="appearance">
  <mat-label>{{labelName}}</mat-label>
  <input matInput [formControl]="trackerFormControl" placeholder="{{placeholder}}" type="{{type}}">
  @if (hasError) {
    <mat-error>{{errorMessage}}</mat-error>
  }
</mat-form-field>